import React from 'react';
import { TopBar } from './components/TopBar';
import { VideoCard } from './components/VideoCard';
import { SpecialNotice } from './components/SpecialNotice';
import { ExchangeRates } from './components/ExchangeRates';
import { GoldRates } from './components/GoldRates';
import { DepositRates } from './components/DepositRates';
export function App() {
  return <div className="relative h-screen w-screen overflow-hidden text-white flex flex-col" data-id="element-0">
      {/* Background gradient base */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(1200px 800px at 10% -10%, #0a4d8c 0%, transparent 60%),' + 'radial-gradient(1000px 700px at 100% 10%, #0066B3 0%, transparent 55%),' + 'radial-gradient(900px 600px at 90% 110%, #2d6b1f 0%, transparent 60%),' + 'linear-gradient(180deg, #001a33 0%, #03224a 50%, #001a33 100%)'
    }} data-id="element-1" />
      <div className="pointer-events-none absolute -top-32 -left-32 h-[420px] w-[420px] rounded-full bg-[#0066B3]/25 blur-3xl animate-float-slow" data-id="element-2" />
      <div className="pointer-events-none absolute top-1/2 -right-40 h-[480px] w-[480px] rounded-full bg-[#7FB539]/15 blur-3xl animate-float-slow-2" data-id="element-3" />
      <div className="pointer-events-none absolute -bottom-40 left-1/3 h-[460px] w-[460px] rounded-full bg-[#003F7D]/40 blur-3xl animate-float-slow" data-id="element-4" />

      <div className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.5'/></svg>\")"
    }} data-id="element-5" />

      {/* Top + main content with padding */}
      <div className="relative flex-1 min-h-0 flex flex-col gap-3 p-4" data-id="element-6">
        <TopBar data-id="element-7" />

        <main className="flex-1 grid grid-cols-12 gap-4 min-h-0" data-id="element-8">
          {/* LEFT — full-height video */}
          <div className="col-span-7 min-h-0" data-id="element-9">
            <VideoCard data-id="element-10" />
          </div>

          {/* RIGHT — Gold (compact) + Deposit (primary), with a clearly visible separator */}
          <div className="col-span-5 flex flex-col min-h-0" data-id="element-11">
            <div className="flex-[3] min-h-0" data-id="element-12">
              <GoldRates data-id="element-13" />
            </div>

            {/* Visible separator zone */}
            <div className="h-24 shrink-0 flex items-center gap-3 px-2" data-id="element-14">
              <div className="h-px flex-1 bg-gradient-to-r from-transparent via-white/25 to-white/25" data-id="element-15" />
              <div className="flex items-center gap-1.5" data-id="element-16">
                <span className="h-1.5 w-1.5 rounded-full bg-white/40" data-id="element-17" />
                <span className="h-1.5 w-1.5 rounded-full bg-white/40" data-id="element-18" />
                <span className="h-1.5 w-1.5 rounded-full bg-white/40" data-id="element-19" />
              </div>
              <div className="h-px flex-1 bg-gradient-to-l from-transparent via-white/25 to-white/25" data-id="element-20" />
            </div>

            <div className="flex-[8] min-h-0" data-id="element-21">
              <DepositRates data-id="element-22" />
            </div>
          </div>
        </main>
      </div>

      {/* Exchange rates bar */}
      <div className="relative px-4 shrink-0" data-id="element-23">
        <div className="h-[104px] mt-1" data-id="element-24">
          <ExchangeRates data-id="element-25" />
        </div>
      </div>

      {/* Special Notice — full-bleed edge-to-edge at the very bottom */}
      <div className="relative h-[60px] shrink-0 mt-3" data-id="element-26">
        <SpecialNotice data-id="element-27" />
      </div>

      {/* Footer below notice */}
      <footer className="relative flex items-center justify-between text-[9px] uppercase tracking-[0.25em] text-white/35 px-4 py-1.5 shrink-0 bg-black/30" data-id="element-28">
        <span data-id="element-29">Commercial Bank of Ceylon PLC · Lobby Display</span>
        <span data-id="element-30">Source: combank.lk · Rates indicative</span>
      </footer>
    </div>;
}